/**
 * Registers the production service worker for PWA installability.
 * Progressive enhancement: failures are ignored.
 */
export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (!('serviceWorker' in navigator) || navigator.serviceWorker == null) {
    return;
  }

  void navigator.serviceWorker.register('/sw.js', {scope: '/'}).catch(() => {
    // Installability is progressive enhancement; do not surface to the user.
  });
}
